import SimpleStatsCard from '@features/analytics/SimpleStatsCard';

const ReturningCustomerRateCard = () => {
  return <SimpleStatsCard label="Returning customer rate" val={0.1} />;
};

export default ReturningCustomerRateCard;
